// src/pages/Login.js
import React, { useState, useContext } from 'react';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import api from '../services/api';
import API_URL from '../config';

const Login = ({ onSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [resetEmail, setResetEmail] = useState(''); // New state for email in the reset modal
  const navigate = useNavigate();
  const { login, refreshUserRole } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post(`${API_URL}/api/users/login`, { email, password });
      login(response.data.token);
      refreshUserRole();

      if (onSuccess) {
        onSuccess();
      } else {
        navigate('/');
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        setMessage('Identifiants incorrects.\n\n Veuillez créer un compte si ce n\'est pas déjà fait.');
      } else {
        setMessage('Erreur de connexion. Veuillez réessayer plus tard.');
      }
    }
  };

  const handleForgotPassword = () => {
    setShowModal(true); // Show the modal for password reset
  };

  const handleSendResetEmail = async () => {
    if (!resetEmail) {
      setMessage('Veuillez renseigner votre adresse email.');
      return;
    }

    try {
      await api.post(`${API_URL}/api/users/password-reset`, { email: resetEmail });
      setMessage('Un email de réinitialisation a été envoyé.');
      setShowModal(false); // Close the modal after sending
    } catch (error) {
      setMessage('Erreur lors de l\'envoi de l\'email de réinitialisation.');
    }
  };

  const goToRegister = () => {
    navigate('/register');
  };

  return (
    <>
      <div className="login-container">
        <form className="login-form" onSubmit={handleSubmit}>
          <h2>Connexion</h2>
          <input
            type="email"
            placeholder="Email (si déjà inscrit)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">Se connecter</button>
          {message && <p className="message">{message}</p>}

          <div className="extra-options">
            <span>Pas encore inscrit ?</span>
            <button onClick={goToRegister} className="register-button">Créer un compte</button>
          </div>

          <div className="forgot-password">
            <button type="button" onClick={handleForgotPassword} className="forgot-password-link">
              Mot de passe oublié ?
            </button>
          </div>
        </form>

        {showModal && (
          <div className="modal">
            <h3>Réinitialisation du mot de passe</h3>
            <input
              type="email"
              placeholder="Votre email"
              value={resetEmail}
              onChange={(e) => setResetEmail(e.target.value)}
              required
            />
            <button onClick={handleSendResetEmail}>Envoyer le lien de réinitialisation</button>
            <button onClick={() => setShowModal(false)}>Annuler</button>
          </div>
        )}
      </div>
    </>
  );
};

export default Login;